const OFFER_KEY = 'qubeyards-site-offer';

export const readOffer = () => {
  try {
    const value = JSON.parse(window.localStorage.getItem(OFFER_KEY) || 'null');
    return value && typeof value === 'object' ? value : null;
  } catch {
    return null;
  }
};

export const saveOffer = (offer) => {
  const next = { ...offer, active: Boolean(offer.active), updatedAt: new Date().toISOString() };
  window.localStorage.setItem(OFFER_KEY, JSON.stringify(next));
  window.dispatchEvent(new Event('qubeyards-offer-updated'));
  return next;
};
